<template>
  <div id="app">
    <AppHeader />
    <transition name="fade" mode="out-in">
      <router-view class="view" />
    </transition>
    <BgImage />

    <transition name="fade">
      <ShareModal v-if="shareModalVisible" />
    </transition>
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader.vue";
import BgImage from "@/components/BgImage.vue";
import ShareModal from "@/components/ShareModal.vue";

import { mapState } from "vuex";

export default {
  components: {
    AppHeader,
    BgImage,
    ShareModal,
  },

  computed: {
    ...mapState({
      shareModalVisible: (state) => state.shareModalVisible,
    }),
  }
};
</script>

<style lang="scss">
@import "./assets/scss/main.scss";
</style>

<style scoped lang="scss">
#app {
  height: 100%;
}

.view {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100vw;
  overflow-x: hidden;

  min-height: 100vh;
  /* mobile viewport bug fix */
  min-height: -webkit-fill-available;

  @include media(">phone") {
    padding: 120px 15px 15px;
  }

  @include media("<=phone") {
    padding: 125px 4vw 4vw;
  }

  &.statements {
    padding-top: 125;

    @include media("<=phone") {
      padding: 125px 4vw 4vw;
    }
  }
}
</style>
